import styled from "styled-components";

export default styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.02em;
  color: #4e5d78;
  margin-bottom: 5px;
`;
